import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));

// StrictMode wrapper that can be conditionally disabled for drag and drop compatibility
const StrictModeWrapper = ({ children }) => {
  // Disable StrictMode in development when using react-beautiful-dnd
  // This is a known compatibility issue with React 18
  const isDevelopment = process.env.NODE_ENV === 'development';
  const disableStrictMode = isDevelopment; // Can be made more specific if needed

  if (disableStrictMode) {
    return children;
  }

  return <React.StrictMode>{children}</React.StrictMode>;
};

root.render(
  <StrictModeWrapper>
    <App />
  </StrictModeWrapper>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
